import { useMutation } from 'react-query';

import { userForceLogout as mutationFn } from 'api/endPoints/userForceLogout';

export const useMutationForceUserLogout = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    username: string;
}
